/**
 * Нижний лист (bottom sheet) — вид выпадающих панелей на телефоне
 * (docs/08-mobile-roadmap.md, M2).
 *
 * Меню, поповер и список выбора на узком экране не привязываются к кнопке:
 * привязанная панель шириной в кнопку мелкая для пальца и упирается в края.
 * Вместо этого панель прижимается к низу экрана во всю ширину, строки
 * крупнее. Headless UI при этом остаётся тем же — меняются только anchor
 * и классы, поэтому клавиатура, фокус и закрытие щелчком снаружи работают
 * как раньше.
 *
 * Затемнение вокруг — тенью самой панели, а не отдельной подложкой:
 * у Menu и Listbox своей подложки нет, а тень закрывает экран без
 * лишнего элемента и не перехватывает щелчок «снаружи».
 */

import { useIsPhone } from "@/shared/lib/media";

/** Панель-лист. `!` перебивает ширину и отступы, заданные вызывающим кодом. */
export const SHEET_PANEL =
  "fixed! inset-x-0! bottom-0! top-auto! z-50 w-full! max-w-none! max-h-[75dvh] overflow-y-auto " +
  "rounded-t-lg! rounded-b-none! border-x-0! border-b-0! border-t border-line bg-raised " +
  "p-2 pb-[calc(0.5rem+var(--safe-bottom))] shadow-[0_0_0_100vmax_rgb(0_0_0/0.4)] focus:outline-none";

/** Строка в листе: цель касания не меньше 44 px, текст крупнее. */
export const SHEET_ROW = "min-h-11 px-3 text-[15px]";

/** Показывать ли выпадающие панели листом. */
export function useSheet(): boolean {
  return useIsPhone();
}
